import React, { useState } from 'react';
import { FaPaperPlane, FaCheckCircle, FaTimesCircle, FaBoxOpen } from 'react-icons/fa';
import { API_BASE } from '../config';
import './ContactPage.css';

const SupplierPage = () => {
  const [formData, setFormData] = useState({
    companyName: '', contactPerson: '', phone: '', email: '',
    sector: '', products: '', message: '',
  });
  const [modal, setModal] = useState({ open: false, type: '', message: '' });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.companyName || !formData.contactPerson || !formData.phone || !formData.email || !formData.sector || !formData.products) {
      setModal({ open: true, type: 'error', message: 'Lütfen zorunlu alanları doldurun.' });
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API_BASE}/supplier-application`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!res.ok) throw new Error();
      setModal({ open: true, type: 'success', message: 'Başvurunuz başarıyla alındı. En kısa sürede sizinle iletişime geçeceğiz.' });
      setFormData({ companyName: '', contactPerson: '', phone: '', email: '', sector: '', products: '', message: '' });
    } catch {
      setModal({ open: true, type: 'error', message: 'Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.' });
    }
    setSending(false);
  };

  return (
    <div className="contact-page">
      {/* Modal */}
      {modal.open && (
        <div className="contact-modal-overlay" onClick={() => setModal({ ...modal, open: false })}>
          <div className="contact-modal" onClick={e => e.stopPropagation()}>
            <div className={`contact-modal-icon ${modal.type}`}>
              {modal.type === 'success' ? <FaCheckCircle /> : <FaTimesCircle />}
            </div>
            <h3 className="contact-modal-title">
              {modal.type === 'success' ? 'Başarılı!' : 'Hata'}
            </h3>
            <p className="contact-modal-message">{modal.message}</p>
            <button className="contact-modal-btn" onClick={() => setModal({ ...modal, open: false })}>
              Tamam
            </button>
          </div>
        </div>
      )}

      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <span className="contact-hero-badge"><FaBoxOpen style={{ marginRight: 6 }} /> TEDARİKÇİ BAŞVURUSU</span>
          <h1 className="contact-hero-title">Tedarikçimiz Olun</h1>
          <p className="contact-hero-desc">
            Restoranlarımız için ürün ve hizmet tedarik etmek isteyen işletmelerin başvuru formudur.
          </p>
        </div>
      </section>

      {/* Form */}
      <section className="contact-main">
        <div className="contact-form-container">
          <div className="contact-form-wrapper">
            <h2 className="contact-form-title">Başvuru Formu</h2>
            <p className="contact-form-desc">
              Lütfen aşağıdaki formu eksiksiz doldurun. Başvurunuz değerlendirildikten sonra sizinle iletişime geçilecektir.
            </p>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Firma Adı *</label>
                  <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} placeholder="Firma ünvanınız" />
                </div>
                <div className="contact-field">
                  <label>Yetkili Kişi *</label>
                  <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} placeholder="Ad Soyad" />
                </div>
              </div>
              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Telefon *</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="05XX XXX XX XX" />
                </div>
                <div className="contact-field">
                  <label>E-posta *</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="info@firma.com" />
                </div>
              </div>
              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Sektör *</label>
                  <select name="sector" value={formData.sector} onChange={handleChange}>
                    <option value="">Seçiniz</option>
                    <option value="gida">Gıda & İçecek</option>
                    <option value="temizlik">Temizlik & Hijyen</option>
                    <option value="mobilya">Mobilya & Ekipman</option>
                    <option value="teknoloji">Teknoloji & Yazılım</option>
                    <option value="tekstil">Tekstil & Üniforma</option>
                    <option value="diger">Diğer</option>
                  </select>
                </div>
                <div className="contact-field">
                  <label>Ürün / Hizmetleriniz *</label>
                  <input type="text" name="products" value={formData.products} onChange={handleChange} placeholder="Tedarik edebileceğiniz ürünler" />
                </div>
              </div>
              <div className="contact-field">
                <label>Ek Bilgi</label>
                <textarea name="message" value={formData.message} onChange={handleChange} rows={4} placeholder="Eklemek istediğiniz bilgiler..." />
              </div>
              <button type="submit" className="contact-submit-btn" disabled={sending}>
                {sending ? 'Gönderiliyor...' : <><FaPaperPlane /> Başvuruyu Gönder</>}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SupplierPage;
